var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href ? 'a' : 'button',_vm._g(_vm._b({tag:"component",class:_vm.buttonClasses,attrs:{"type":!_vm.href && _vm.type,"disabled":_vm.disabled}},'component',Object.assign({}, (_vm.href && { href: _vm.href }),
    (_vm.target && {
      rel: 'noreferrer noopener',
      target: _vm.target,
    })),false),_vm.listeners),[(_vm.isSpinnerActive)?[_c('Spinner',{class:_vm.spinnerClasses})]:_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }